import { render, staticRenderFns } from "./messageShare.vue?vue&type=template&id=7ded7a64&scoped=true&"
import script from "./messageShare.vue?vue&type=script&lang=js&"
export * from "./messageShare.vue?vue&type=script&lang=js&"
import style0 from "./messageShare.vue?vue&type=style&index=0&id=7ded7a64&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ded7a64",
  null
  
)

export default component.exports